import { Component, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { DocumentInformationNoteComponent } from '../../../core/component/information-note-base/document-information-note';
import { PropertyDocument } from '../../model/property-document';
import { PropertyDocumentService } from '../../service/data/property-document-service';

@Component({
    selector: 'app-property-information-note',
    templateUrl: './../../../core/component/information-note/information-note.component.html',
    styleUrls: ['./../../../core/component/information-note/information-note.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PropertyDocumentInformationNoteComponent extends DocumentInformationNoteComponent<PropertyDocument> {
  @ViewChild('tooltip') tooltipBlock: ElementRef<HTMLInputElement>;
  @ViewChild('tooltipIcon') tooltipIcon: ElementRef<HTMLInputElement>;

  constructor(_renderer: Renderer2, propertyDocumentService: PropertyDocumentService, nativeWindow: NativeWindowService) {
    super(_renderer, propertyDocumentService, nativeWindow);
  }

  isClickable = true;
}
